import { Loader } from '@pwc/pwc-deals-ui';
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useParams } from 'react-router-dom';

import { formatSurveyRoute } from '../../Survey/routes';
import {
  getDivestitureDiagnosticResults,
  getFetchDivestitureDiagnosticResultsStatus,
} from './divestitureDiagnosticSlice';
import Category from '../../common/components/DivestitureDiagnosticResults/Category/Category';

const ResultsRouter = () => {
  const { projectId } = useParams();
  const results = useSelector(getDivestitureDiagnosticResults);
  const { pending: fetchingResults, success: fetchDDSuccess } = useSelector(
    getFetchDivestitureDiagnosticResultsStatus
  );

  return (
    <>
      {fetchingResults && <Loader />}
      {!fetchingResults && fetchDDSuccess && (
        <>
          {!results && <Redirect to={formatSurveyRoute(projectId)} />}
          {results && <Category />}
        </>
      )}
    </>
  );
};

export default ResultsRouter;
